<template>
  <div>
    <headerSection></headerSection>

    <div class="reward-page" :style="pageBackgroundStyle">
      <div class="container reward-shell">
        <section class="reward-hero">
          <div class="reward-hero__panel">
            <p class="reward-hero__eyebrow">
              <i class="fas fa-users"></i>
              Partner Program
            </p>
            <h1 class="reward-hero__title">ลิงก์รับทรัพย์</h1>
            <p class="reward-hero__desc">
              แชร์ลิงก์แนะนำเพื่อน ติดตามจำนวนสมาชิกที่เข้าร่วม และดูรายได้จากสายงาน
              ทั้งสองระดับได้ในหน้าเดียว
            </p>

            <div class="reward-chip-row">
              <span class="reward-chip">
                <i class="fas fa-link"></i>
                รหัสแนะนำ {{ user && user.code ? user.code : '-' }}
              </span>
              <span class="reward-chip is-muted">
                <i class="fas fa-chart-line"></i>
                ข้อมูลสรุปยอดล่าสุดของวันนี้
              </span>
            </div>
          </div>

          <div class="reward-hero__panel reward-hero__panel--compact">
            <div>
              <p class="reward-card__label">ลิงก์สำหรับแชร์</p>
              <div class="reward-link-box">
                <input
                  id="copyTarget3"
                  type="text"
                  readonly="readonly"
                  class="reward-link-input"
                  :value="shareLink"
                >
                <button
                  id="copyButton3"
                  class="reward-inline-button"
                  v-clipboard:copy="shareLink"
                  v-clipboard:success="clipboardSuccessHandler"
                >
                  <i class="fa fa-copy"></i>
                  คัดลอกลิงก์
                </button>
              </div>
            </div>

            <div class="reward-note-list">
              <div class="reward-note">
                <i class="fas fa-share-alt"></i>
                <div>
                  <strong>ส่งต่อได้ทุกช่องทาง</strong>
                  <span>ส่งลิงก์แนะนำเพื่อนได้ทันทีทั้งแชต กลุ่ม หรือโซเชียลของคุณ</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="reward-section">
          <div class="reward-section__header">
            <div>
              <h2 class="reward-section__title">รายได้ผู้แนะนำ</h2>
              <p class="reward-section__subtext">
                ดูจำนวนสมาชิกในแต่ละระดับ และยอดรายได้รวมที่รอรับเข้า wallet
              </p>
            </div>

            <span class="reward-chip">
              <i class="fas fa-wallet"></i>
              พร้อมโอน {{ numberWithCommas(partner.total) }}
            </span>
          </div>

          <div class="reward-card-grid">
            <article
              v-for="card in partnerStats"
              :key="card.key"
              :class="['reward-card', card.className]"
            >
              <p class="reward-card__label">{{ card.label }}</p>
              <p :class="['reward-card__value', { 'reward-card__value--sm': card.smallValue }]">
                {{ card.value }}
              </p>
              <p class="reward-card__caption">{{ card.caption }}</p>

              <div class="reward-card__footer">
                <span class="reward-card__meta">{{ card.meta }}</span>
                <button
                  v-if="card.level"
                  type="button"
                  class="reward-inline-button is-secondary partner-detail-button"
                  @click="showlevel(card.level)"
                >
                  ดูรายการ
                </button>
                <span v-else class="reward-card__icon">
                  <i :class="card.icon"></i>
                </span>
              </div>
            </article>
          </div>

          <div class="reward-action-row">
            <div>
              <button
                type="button"
                :class="['reward-button', { 'is-disabled': !canTransfer }]"
                :disabled="!canTransfer"
                @click="movePartnerToWallet()"
              >
                <i class="fas fa-exchange-alt"></i>
                โอนเงินเข้ากระเป๋าหลัก
              </button>
              <span class="reward-button__subtext">
                ยอดรายได้จะรีเฟรชใหม่อัตโนมัติหลังทำรายการ
              </span>
            </div>
          </div>
        </section>

        <section class="reward-section reward-section--compact">
          <div class="reward-section__header">
            <div>
              <h2 class="reward-section__title">รายละเอียดโปรแกรมแนะนำ</h2>
              <p class="reward-section__subtext">
                ประกาศ เงื่อนไข และรายละเอียดการรับรายได้จากระบบ partner
              </p>
            </div>
          </div>

          <div class="reward-rich-text" v-html="nl2br(detail)"></div>
        </section>
      </div>
    </div>

    <div v-if="showdetail" class="reward-modal-backdrop" @click.self="closeDetail()">
      <div class="reward-modal">
        <button type="button" class="reward-modal__close" @click="closeDetail()">
          <i class="fas fa-times"></i>
        </button>

        <p class="reward-modal__eyebrow">ข้อมูลสรุปยอดเมื่อวาน</p>
        <h2 class="reward-modal__title">{{ titleDetail }}</h2>

        <div class="reward-table-card" style="margin-top: 18px;">
          <div v-if="history.length" class="reward-table-wrap reward-table-wrap--tall">
            <table class="reward-table">
              <thead>
                <tr>
                  <th class="reward-table__center">รหัส</th>
                  <th class="reward-table__center">วันที่</th>
                  <th class="reward-table__number">ฝาก</th>
                  <th class="reward-table__number">ถอน</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in history" :key="index">
                  <td class="reward-table__center reward-table__strong">{{ item.code }}</td>
                  <td class="reward-table__center">{{ item.createdateShow }}</td>
                  <td class="reward-table__number">{{ numberWithCommas(item.deposit) }}</td>
                  <td class="reward-table__number">{{ numberWithCommas(item.withdraw) }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-else class="reward-empty">
            <strong>ยังไม่มีข้อมูลในช่วงเวลานี้</strong>
            ระบบยังไม่พบรายการสำหรับกลุ่มที่เลือกในสรุปยอดเมื่อวาน
          </div>
        </div>

        <div class="reward-modal__footer">
          <span class="reward-contact">
            <i class="fas fa-headset"></i>
            ติดปัญหา
            <a href="https://lin.ee/V8UzUpg" target="_blank" rel="noopener">ติดต่อฝ่ายบริการลูกค้า</a>
          </span>
        </div>
      </div>
    </div>

    <footerSection></footerSection>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import router from './../router'
import moment from 'moment-timezone'
const axios = require('axios').default

export default {
  name: 'Partner',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue')
  },
  created () {
    const user = localStorage.getItem('userData')
    if (user) {
      const _user = JSON.parse(user)
      this.$store.dispatch('user/setUser', _user).catch(err => { console.error(err) })
    } else {
      firebase.auth().signOut()
      localStorage.removeItem('userData')
      router.replace('/login')
    }
  },
  data: function () {
    return {
      partner: [],
      showdetail: false,
      titleDetail: '',
      history: [],
      detail: ''
    }
  },
  mounted () {
    this.scrollToTop()
    this.getPartner()
  },
  computed: {
    user () {
      return this.$store.state.user.user
    },
    pageBackgroundStyle () {
      return {
        backgroundImage: `linear-gradient(180deg, rgba(7, 13, 28, 0.32) 0%, rgba(7, 13, 28, 0.85) 100%), url(${require('../assets/images/Shiba-BG.jpg')})`
      }
    },
    shareLink () {
      return `https://cow888.co/register?ref=${this.user && this.user.code ? this.user.code : ''}`
    },
    canTransfer () {
      return !!(this.partner && this.partner.total > 0)
    },
    partnerStats () {
      return [
        {
          key: 'level1',
          label: 'แนะนำเพื่อน',
          value: this.formatInteger((this.user && this.user.level1) ? Object.keys(this.user.level1).length : 0),
          caption: 'สมาชิกที่คุณแนะนำโดยตรง',
          meta: 'Level 1',
          icon: 'fas fa-users',
          className: 'reward-card--info',
          level: 1
        },
        {
          key: 'level2',
          label: 'เพื่อนแนะนำเพื่อน',
          value: this.formatInteger((this.user && this.user.level2) ? Object.keys(this.user.level2).length : 0),
          caption: 'สมาชิกที่เกิดจากสายงานชั้นที่ 2',
          meta: 'Level 2',
          icon: 'fas fa-project-diagram',
          className: '',
          level: 2
        },
        {
          key: 'total1',
          label: 'รายได้แนะนำเพื่อน',
          value: this.numberWithCommas(this.partner.total1),
          caption: 'รายได้จากสมาชิกชั้นที่ 1',
          meta: 'Income',
          icon: 'fas fa-coins',
          className: 'reward-card--success'
        },
        {
          key: 'total2',
          label: 'รายได้เพื่อนแนะนำเพื่อน',
          value: this.numberWithCommas(this.partner.total2),
          caption: 'รายได้จากสมาชิกชั้นที่ 2',
          meta: 'Sub income',
          icon: 'fas fa-money-bill-wave',
          className: ''
        },
        {
          key: 'total',
          label: 'รายได้ทั้งหมด',
          value: this.numberWithCommas(this.partner.total),
          caption: 'ยอดรวมที่สามารถโอนเข้ากระเป๋าหลักได้',
          meta: 'Available now',
          icon: 'fas fa-wallet',
          className: 'reward-card--accent reward-card--span-2'
        }
      ]
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    movePartnerToWallet () {
      if (this.partner.total && this.partner.key) {
        this.$store.commit('user/SET_LOADING', true)
        axios.get(`https://api.cow888.fun/qpartner/partner/${this.partner.key}`)
        setTimeout(() => {
          this.getPartner()
          this.$store.commit('user/SET_LOADING', false)
        }, 2000)
      }
    },
    clipboardSuccessHandler () {
      this.$swal({ icon: 'success', title: 'Copy', text: 'คัดลอกเรียบร้อยแล้ว' })
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        const _user = JSON.parse(user)
        return _user
      } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/login')
      }
    },
    formatInteger (x) {
      const total = Number(x || 0)
      return total.toLocaleString()
    },
    numberWithCommas (x) {
      if (!x) x = 0
      return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    async getPartner () {
      this.detail = (await firebase.database().ref('/partner/detail').once('value')).val()
      const user = this.getUserId()
      if (user) {
        firebase.firestore().collection('partner').where('date', '==', moment().tz('Asia/Bangkok').format('YYYY-MM-DD')).where('userkey', '==', user.key).where('status', '==', false).get().then((snapshot) => {
          if (!snapshot.size) this.partner = []
          snapshot.forEach((doc) => {
            const data = doc.data()
            data.key = doc.id
            this.partner = data
          })
        })
      }
    },
    nl2br (str, isXhtml) {
      if (typeof str === 'undefined' || str === null) {
        return ''
      }
      const breakTag = (isXhtml || typeof isXhtml === 'undefined') ? '<br />' : '<br>'
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2')
    },
    async showlevel (level) {
      const history = []
      const deposit = []
      const withdraw = []
      if (level === 1) {
        this.titleDetail = 'แนะนำเพื่อน'
        await firebase.firestore().collection('daily_deposit').where('createdate', '==', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('level1', '==', this.user.code).get().then((snapshot) => {
          snapshot.forEach((doc) => {
            deposit[doc.data().code] = doc.data().total
          })
        })
        await firebase.firestore().collection('daily_withdraw').where('createdate', '==', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('level1', '==', this.user.code).get().then((snapshot) => {
          snapshot.forEach((doc) => {
            withdraw[doc.data().code] = doc.data().total
          })
        })
        if (this.user.level1) {
          for (const x in this.user.level1) {
            if (deposit[this.user.level1[x].code]) {
              this.user.level1[x].deposit = deposit[this.user.level1[x].code]
            } else {
              this.user.level1[x].deposit = 0
            }
            if (withdraw[this.user.level1[x].code]) {
              this.user.level1[x].withdraw = withdraw[this.user.level1[x].code]
            } else {
              this.user.level1[x].withdraw = 0
            }
            this.user.level1[x].createdateShow = moment().add(-1, 'days').format('DD MMM,YY')
            history.push(this.user.level1[x])
          }
        }
      } else {
        this.titleDetail = 'เพื่อนแนะนำเพื่อน'
        await firebase.firestore().collection('daily_deposit').where('createdate', '==', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('level2', '==', this.user.code).get().then((snapshot) => {
          snapshot.forEach((doc) => {
            deposit[doc.data().code] = doc.data().total
          })
        })
        await firebase.firestore().collection('daily_withdraw').where('createdate', '==', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('level2', '==', this.user.code).get().then((snapshot) => {
          snapshot.forEach((doc) => {
            withdraw[doc.data().code] = doc.data().total
          })
        })
        if (this.user.level2) {
          for (const x in this.user.level2) {
            if (deposit[this.user.level2[x].code]) {
              this.user.level2[x].deposit = deposit[this.user.level2[x].code]
            } else {
              this.user.level2[x].deposit = 0
            }
            if (withdraw[this.user.level2[x].code]) {
              this.user.level2[x].withdraw = withdraw[this.user.level2[x].code]
            } else {
              this.user.level2[x].withdraw = 0
            }
            this.user.level2[x].createdateShow = moment().add(-1, 'days').format('DD MMM,YY')
            history.push(this.user.level2[x])
          }
        }
      }
      this.history = history
      this.showdetail = true
    },
    closeDetail () {
      this.showdetail = false
    }
  }
}
</script>

<style scoped>
.partner-detail-button {
  min-height: 40px;
  padding: 0 16px;
  font-size: 0.88rem;
}
</style>
